import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ProductbatchTechnicalfeatureAddComponent } from '../../../components/productbatch-technicalfeature-add/productbatch-technicalfeature-add.component';
import { Batch, ProductBatchTechnicalFeature, TechnicalFeature, ValueTypes } from 'src/app/models';
import { GenericResource } from 'src/app/resources';
import { TranslateService } from '@ngx-translate/core';
import { MasterApiService } from 'src/app/services/master-api.service';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { DxTagBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-product-batch-technical-features',
    templateUrl: './product-batch-technical-features.component.html',
    styleUrl: './product-batch-technical-features.component.sass',
    standalone: false
})
export class ProductBatchTechnicalFeaturesComponent implements OnInit, OnDestroy {

  @Input() entity?: Batch;
  technicalFeaturesValues: { value: string, display: string }[] = [];
  technicalFeatures: TechnicalFeature[] = [];
  technicalFeatureAdd = ProductbatchTechnicalfeatureAddComponent;
  destroy$: Subject<void>;
  technicalFeatureValueTypes = ValueTypes.map(_ => ({ id: _.id, name: this.translationService.instant(`enumeration.ValueTypes.${_.name}`) }));
  productBatchTechnicalFeatures?: GenericResource<ProductBatchTechnicalFeature>;

  constructor(private translationService: TranslateService, private api: MasterApiService) {
    this.destroy$ = new Subject<void>();
  }
  async ngOnInit(): Promise<void> {
    this.productBatchTechnicalFeatures = this.api.resources.product.productBatchTechnicalFeatures(this.entity!.id);
    this.technicalFeatures = await this.getTechnicalFeatures();
  }

  getTechnicalFeatures = async () => {
    const tfs = await firstValueFrom(this.api.resources.product.technicalfeatures.getAll({ companyId: this.api.auth.userValue?.lastCompanyId }));

    return tfs.map(tf => {
      const type = this.technicalFeatureValueTypes.find(_ => _.id == tf.valueTypeId);
      return {
        ...tf,
        valueTypeName: type?.name
      }
    });
  }
  rowIsValueType(type:number, row:any) {
    const id = row.data.technicalFeatureId;
    const valueTypeId = this.technicalFeatures.find(tf => tf.id === id)?.valueTypeId;
    return type === valueTypeId;
  }

  getValuesFromTechnicalFeatures(row:any) {
    const id = row.data.technicalFeatureId;
    const values = this.technicalFeatures.find(tf => tf.id === id)?.values;

    this.technicalFeaturesValues = [];
    if(values)
      this.technicalFeaturesValues = values.map(value => ({ value, display: value }));
  }
    
  @ViewChild('tagBox', { static: false }) tagBox?:DxTagBoxComponent;
  onInitTagBoxValue: string[] = [];

  getValuesFromTechnicalFeaturesTagBox(row:any) {
    const id = row.data.technicalFeatureId;
    const values = this.technicalFeatures.find(tf => tf.id === id)?.values;

    this.technicalFeaturesValues = [];
    if(values)
      this.technicalFeaturesValues = values.map(value => ({ value, display: value }));

    this.onInitTagBoxValue = row.value.split(',');

    this.tagBox!.onValueChanged.pipe(takeUntil(this.destroy$)).subscribe(async e => {
      if(e.value !== e.previousValue)
        if (e.value !== undefined || this.technicalFeaturesValues.includes(e.value))
          row.setValue(e.value.toString())
    });
  }
  rowSetValue(type:number, row:any) {
    if (!row.value)
      return;

    let value = row.value;
    if ((type === 1 || type === 2) && isNaN(value))
      value = '0';

    if (type === 1)
      value = Math.round(value);

    row.setValue(value.toString());
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
